<template>
  <div class="card">
    <div class="card-header">
      <div class="flex justify-between">
        <div>
          <h2 class="card-heading">Tarrifs</h2>
        </div>
        <!-- <div class="card-subheading">

            <a :href="fulltarrifbook" target="_blank" rel="noopener noreferrer">
                <p>Download Tarrif Book</p>
            </a>
        </div> -->
      </div>
    </div>
    <div class="card-content">
      <div class="w-full">
        <!-- <div v-for="item in tarrifs" v-bind:key="item.pos" class="w-full p-2 text-xs bg-slate-200 rounded mt-2">
            <a :href="item.link" target="_blank" rel="noopener noreferrer">
                <p  class="hover:text-blue-500 cursor-pointer">{{item.name}}</p>
            </a>
        </div> -->

        <a :href="fulltarrifbook" target="_blank" rel="noopener noreferrer">
          <button class="text-white hover:text-white/80 bg-primary w-full rounded-lg p-2 mt-2 transition ease-in-out">
            Download Tariff Book
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from "vue-property-decorator";
import BandharuService from "@/services/bandharu.service";

@Component({
})
export default class Tarrifs extends Vue {
  private service = new BandharuService();

  private settings = {
    userDropdown: false,
    notificationDropdown: false,
  };

  private loading = false;

  private result = null;

  private form = {
    container: "",
  };

  private tarrifs = [
    {
      name: 'Marine Service Charges',
      type: 'MCH',
      link: 'https://portmvuploads.s3-ap-southeast-1.amazonaws.com/CHARGES+FOR+MARINE+SERVICES.pdf'
    },
    {
      name: 'Container Operations',
      type: 'MCH',
      link: 'https://portmvuploads.s3-ap-southeast-1.amazonaws.com/CHARGES+FOR+CONTAINER+OPERATIONS.pdf'
    },
    {
      name: 'Conventional Operations',
      type: 'MCH',
      link: 'https://portmvuploads.s3-ap-southeast-1.amazonaws.com/CHARGES+FOR+CONVENTIONAL+OPERATIONS.pdf'
    },
    {
      name: 'International Transhipment Cargo',
      type: 'MCH',
      link: 'https://portmvuploads.s3-ap-southeast-1.amazonaws.com/CHARGES+FOR+INTERNATIONAL+TRANSSHIPMENT+CARGO.pdf'
    },
    {
      name: 'Other Charges',
      type: 'MCH',
      link: 'https://portmvuploads.s3-ap-southeast-1.amazonaws.com/OTHER+CHARGES.pdf'
    },
  ]


  private fulltarrifbook = 'https://port.mv/tariff/';

  resetResults() {
    this.form.container = "";
    this.result = null;
  }

  search() {
    this.loading = true;

    this.resetResults();

    this.service.searchContainer(this.form.container)
        .then((res) => {
          console.log(res.data.data);
          this.result = res.data;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error Searching Container");
        });
  }

  viewUserDropdown() {
    this.settings.userDropdown = true;
  }

  hideUserDropdown() {
    this.settings.userDropdown = false;
  }

  viewNotifications() {
    this.settings.notificationDropdown = true;
  }

  hideNotifications() {
    this.settings.notificationDropdown = false;
  }
}
</script>
